import { ShippingService } from '@/services/api'

// Statuses from which a carrier may assign a courier (CONFIRMED always has one)
const ASSIGNABLE_STATUSES = ['WAITING', 'READY', 'INCIDENCE']

export default {
  methods: {
    /**
     * Mirrors the backend eligibility of POST carriers/{id}/shippings/{fk}/assign (MOOV-5434):
     * no courier, no tour, not outsourced, not a return leg, and WAITING or of the carrier's company.
     * Missing flags count as "not set": the backend stays the last guard.
     */
    isCarrierAssignable(shipping) {
      if (!shipping || !ASSIGNABLE_STATUSES.includes(shipping.status)) return false
      if (shipping.courier_id || shipping.courier?.id) return false
      if (shipping.tour_id || shipping.is_outsourced || shipping.depends_on_shipping_id) return false

      return shipping.status === 'WAITING' ||
        String(shipping.courier_company_id) === String(this.profile?.company_id)
    },
    // The error is reported by showAssignError, not by the global HTTP alert
    assignShippingToCourier(shippingId, courierId) {
      return ShippingService.assign(shippingId, courierId, { skipErrorAlert: true })
    },
    assignErrorMessage(error) {
      if (error?.status === 428 || error?.status === 409) {
        return this.$gettext('Sorry! The shipping has been taken by other courier before.')
      }
      if (error?.status === 404) {
        return this.$gettext('The shipment or the courier is no longer available.')
      }
      return this.$gettext('There were unexpected errors. Please try again.')
    },
    showAssignError(error) {
      this.$root.$children[0].$refs.simplert.openSimplert({
        title: 'ERROR',
        message: this.assignErrorMessage(error),
        type: 'error',
        customCloseBtnText: this.$gettext('Close')
      })
    }
  }
}
